import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Catalog from '../views/Catalog.vue'
import Title from '../views/Title.vue'
import About from '../views/About.vue'


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/movies',
        name: 'Movies',
        component: Catalog,
        props: (route) => (
            {
                keywords: route.query.keywords,
                sort: route.query.sort,
                catalogType: 'movie'
            })
    },
    {
        path: '/movie/:id',
        name: 'Movie',
        component: Title,
        props: () => (
            {
                titleType: 'movie'
            })
    },
    {
        path: '/show/:id',
        name: 'Show',
        component: Title,
        props: () => (
            {
                titleType: 'show'
            })
    },
    {
        path: '/shows',
        name: 'Shows',
        component: Catalog,
        props: (route) => (
            {
                keywords: route.query.keywords,
                sort: route.query.sort,
                catalogType: 'show'
            })

    },
    {
        path: '/about',
        name: 'About',
        component: About
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
